class IslanderJournal {
  constructor(section) {
    this.section = section;
    this.grid = section.querySelector('[data-journal-grid]');
    this.cards = this.grid ? Array.from(this.grid.querySelectorAll('[data-journal-card]')) : [];
    this.initialCount = this.cards.filter(
      (card) => !card.classList.contains('islander-journal-card--initially-hidden')
    ).length;
    this.sort = section.querySelector('[data-journal-sort]');
    this.toggle = section.querySelector('[data-journal-toggle]');
    this.filterLinks = Array.from(section.querySelectorAll('[data-journal-filter]'));
    this.expanded = false;
    this.loading = false;

    this.sort?.addEventListener('change', () => this.sortArticles());
    this.toggle?.addEventListener('click', () => this.toggleArticles());
    this.filterLinks.forEach((link) => {
      link.addEventListener('click', (event) => this.filterArticles(event, link));
    });
  }

  filterArticles(event, link) {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      link.target === '_blank'
    ) {
      return;
    }

    event.preventDefault();
    this.loadArticles(link.href, true);
  }

  async loadArticles(url, updateHistory = false) {
    if (this.loading) return;

    this.loading = true;
    this.section.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(url, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      if (!response.ok) {
        throw new Error(`Unable to load Journal articles (${response.status})`);
      }

      const html = await response.text();
      const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
      const nextSection = parsedDocument.querySelector('#JournalArticles[data-islander-journal]');

      if (!nextSection) {
        throw new Error('Journal articles section was not found in the response');
      }

      this.section.replaceWith(nextSection);

      if (updateHistory) {
        history.pushState({ islanderJournal: true }, '', url);
      }

      initializeIslanderJournals(nextSection.parentElement || document);
    } catch (error) {
      window.location.assign(url);
    } finally {
      if (this.section.isConnected) {
        this.section.removeAttribute('aria-busy');
      }
      this.loading = false;
    }
  }

  sortArticles() {
    if (!this.grid) return;

    const direction = this.sort.value === 'oldest' ? 1 : -1;
    this.cards
      .sort((firstCard, secondCard) => {
        const firstDate = Number(firstCard.dataset.published);
        const secondDate = Number(secondCard.dataset.published);
        return (firstDate - secondDate) * direction;
      })
      .forEach((card) => this.grid.appendChild(card));

    this.updateCards();
  }

  toggleArticles() {
    this.expanded = !this.expanded;
    this.updateCards();

    this.toggle.setAttribute('aria-expanded', String(this.expanded));
    this.toggle.textContent = this.expanded ? this.toggle.dataset.hideLabel : this.toggle.dataset.showLabel;

    if (!this.expanded) {
      this.grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  updateCards() {
    this.cards.forEach((card, index) => {
      card.classList.toggle('islander-journal-card--initially-hidden', index >= this.initialCount);
      card.style.display = this.expanded ? 'flex' : '';
    });
  }
}

const initializeIslanderJournals = (root = document) => {
  root.querySelectorAll('[data-islander-journal]').forEach((section) => {
    if (!section.islanderJournal) {
      section.islanderJournal = new IslanderJournal(section);
    }
  });
};

document.addEventListener('DOMContentLoaded', () => initializeIslanderJournals());

document.addEventListener('shopify:section:load', (event) => {
  initializeIslanderJournals(event.target);
});

window.addEventListener('popstate', () => {
  const section = document.querySelector('#JournalArticles[data-islander-journal]');
  if (!section) return;

  initializeIslanderJournals(section.parentElement || document);
  section.islanderJournal?.loadArticles(window.location.href);
});
